import { Colors } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { formatGraphTimeTitle } from 'modules/project_management/lib/formatChartComponents'

export type ConstantTransformedDataId = 'planned_cost' | 'planned_income' | 'time_budget'

export type EvolutionTransformedDataId = 'registered_hours' | 'registered_cost'

export type ConstantTransformedData = {
  id: ConstantTransformedDataId
  label: string
  value: number
  color: Colors
}

export type EvolutionTransformedData = {
  id: EvolutionTransformedDataId
  label: string
  max: number
  min: number
  data: EvolutionGraphData[]
  color: Colors
}

export type EvolutionGraphData = {
  x: number
  y: number
  title: string
}

export type EvolutionTransformedGraphData = {
  data: BarsGraphData[]
}

export type BarsGraphData = {
  value: number
  title: string
  color: string
}

export type ProjectTimeGraph = {
  year: string
  timeSlot: string
  imputedMinutes?: number | null | undefined
}

export const getEvolutionTransformedData = (data: ProjectTimeGraph[], slotType: string) => {
  const max = data.map((item) => item.imputedMinutes || 0).reduce((a, b) => Math.max(a, b), 0) / 60
  const min = data[0]?.imputedMinutes ? data[0].imputedMinutes / 60 : 0

  const transformedData: EvolutionTransformedData = {
    id: 'registered_hours',
    label: i18n.t('project_management.graphs.evolution.time.legends.registered_hours'),
    max: max,
    min: min,
    data: [],
    color: 'viridian1000',
  }

  data.forEach((item, index) => {
    transformedData.data.push({
      x: index,
      y: (item.imputedMinutes || 0) / 60,
      title: index !== 0 ? formatGraphTimeTitle(item.year, item.timeSlot, slotType) : '',
    })
  })

  return transformedData
}
